<section class="auth-page">
  <app-animated-bg></app-animated-bg>
  <div class="auth-container">
    <div class="auth-card">
      <div class="auth-label">Welcome,</div>
      <div *ngIf="clientConfig && clientConfig.logoUrl" class="auth-logo">
        <img src="{{clientConfig.logoUrl}}" alt="{{clientConfig.name}}" draggable="false" />
      </div>
      <h1 class="auth-title">Set Password</h1>
      <div>
        <div class="input">
          <label for="password" class="hidden">Password</label>
          <input type="password" placeholder="Password" autocomplete="new-password" (keyup)="updatePassword($event)" required>
        </div>
        <div class="input">
          <label for="passwordi" class="hidden">Repeat Password</label>
          <input type="password" placeholder="Repeat Password" autocomplete="new-password" (keyup)="updatePasswordi($event)" required>
        </div>
        <div class="error">{{error}}</div>
        <div class="form-actions right">
          <a [routerLink]="['/sign-in']">Sign In</a>
          <button class="button" [class.disabled]="!validInput || processing" (click)="resetPassword()">Set Password</button>
        </div>
      </div>
    </div>
  </div>

  <div class="powered-by">
    powered by
    <img src="assets/global/logo-red-fire.svg" alt="Red Fire Technology" draggable="false">
  </div>
</section>
